import * as yup from "yup";
import { TFunction } from "i18next";

export const schema = (t: TFunction) => {
  return yup
    .object({
      username: yup.string().required(),
      email: yup
        .string()
        .email(t("contactUs.input.validation.email.text"))
        .required(),
      phoneNumber: yup.string().required(),
      comments: yup.string().required(),
    })
    .required();
};
